<template lang="pug">
.TopPage
  .container
    .main
      .title
        img(src="@/assets/logo.svg" alt="")
        .trialMark(v-if="constants.IS_TRIAL") 体験版
      .menu
        .menuItem.menuItem--lesson(
          @click="handleMenuClick('lesson')"
          v-menuHoverSound
          v-menuClickSound
        )
          .buttonTitle
            | 基本レッスン
            .nextLabel {{lesson.nextStage.isCompleted ? 'クリア' : `次は${this.lesson.nextStage.area}-${this.lesson.nextStage.stage}から`}}
          .lessonProgress
            .label {{lesson.progressPercentage}}%
            .progressCircle
              svg(viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg")
                circle.base(cx="18" cy="18" r="15.9155")
                circle.current(cx="18" cy="18" r="15.9155" :style="lessonProgressCurrentStyle")

        .menuItem.menuItem--routine(
          @click="handleMenuClick('routine')"
          :class="{ 'menuItem--disabled': false }"
          v-menuHoverSound
          v-menuClickSound
        )
          span ルーティーン
          .comboLabel(v-if="routineResult.lastDate >= yesterday")
            | {{routineResult.comboCount}}日連続!
          .calendar
            km-result-mini-calendar(:dates="routineResultDates")
          .taskIcon(v-if="routineResult.lastDate !== today") 未

        .menuItem(
          @click="handleMenuClick('speedup')"
          :class="{ 'menuItem--disabled': false }"
          v-menuHoverSound
          v-menuClickSound
        ) スピードアップ<br>ゲーム

        .menuItem(
          @click="handleMenuClick('challenge')"
          :class="{ 'menuItem--disabled': false }"
          v-menuHoverSound
          v-menuClickSound
        ) 測定<br>チャレンジ

        .menuItem(
          @click="handleMenuClick('customize')"
          v-menuHoverSound
          v-menuClickSound
        ) 設定

      .footer
        .footerLeftMenu
          .helpButton(
            @click="handleHelpClick()"
            v-menuHoverSound
            v-menuClickSound
          ) ヘルプ
          a.contactButton(
            href="https://forms.gle/LSRJDy5W8ZeiVZnJA"
            target="_new"
            v-menuHoverSound
            v-menuClickSound
          ) お問い合わせ

        .footerRightMenu
          km-rank-badge.rankBadge(
            :score="challengeResult.best.score"
            :layout="'horizontal'"
            :size="50"
            @click="handleBadgeClick()"
          )
          .userName {{account.name}}
          //- .level レベル: {{lvl}}
          //- .exp 経験値: {{exp}}
          //- .point ポイント: {{point}} ポイント
          .logoutButton(
            @click="handleLogoutButtonClick"
            v-menuHoverSound
            v-menuClickSound
          ) ログアウト
    .version v{{constants.VERSION}} | <a href="https://kd.koredake.net/assets/200925_KD_Terms.pdf" target="_new">利用規約</a>
    .bg
    km-loading-overlay(
      v-if="assetLoaded === false"
      :queuedAssets="assets"
      :loadedAssets="loadedAssets"
    )
    km-loading-overlay(
      v-if="loadingOverlaySettings.visibled"
      :type="constants.LOADING_OVERLAY_TYPE.LABEL"
      :message="loadingOverlaySettings.message"
    )
    km-walkthrough-modal(
      v-if="walkthroughModalEnabled"
      :pages="walkthroughPages"
      @onClose="handleWalkthroughModalClose"
    )

</template>

<script>
import * as _ from 'lodash'
import moment from 'moment'
import { mapState, mapActions, mapGetters } from 'vuex'
import * as constants from '@/constants'
import firebaseService from '@/services/FirebaseService'
import RankBadge from '@/components/shared/RankBadge'
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import ResultMiniCalendar from '@/components/routine/ResultMiniCalendar.vue'
import WalkthroughModal from '@/components/shared/WalkthroughModal'

export default {
  name: 'top-page',
  components: {
    'km-rank-badge': RankBadge,
    'km-loading-overlay': LoadingOverlay,
    'km-result-mini-calendar': ResultMiniCalendar,
    'km-walkthrough-modal': WalkthroughModal
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result,
      routineResult: state => state.routine_result
    }),
    ...mapState('Assets', {
      loadedAssets: state => state.assets
    }),
    ...mapGetters('User', ['currentLessonProgressCount']),
    lessonProgressCurrentStyle() {
      return {
        'stroke-dasharray': `${this.lesson.progressPercentage}, 100`
      }
    },
    routineResultDates() {
      return this.routineResult.records.map((record) => {
        return record.date
      })
    }
  },
  data() {
    return {
      constants,
      assetLoaded: null,
      assets: [
        { type: 'image', path: require('@/assets/logo.svg') },
        { type: 'image', path: require('@/assets/bg_wood.jpg') },
        { type: 'image', path: require('@/assets/badge_1.png') },
        { type: 'image', path: require('@/assets/badge_2.png') },
        { type: 'image', path: require('@/assets/badge_3.png') },
        { type: 'image', path: require('@/assets/badge_4.png') },
        { type: 'image', path: require('@/assets/badge_5.png') },
        { type: 'image', path: require('@/assets/badge_6.png') },
        { type: 'image', path: require('@/assets/badge_7.png') },
        { type: 'image', path: require('@/assets/badge_8.png') },
        { type: 'image', path: require('@/assets/badge_9.png') },
        { type: 'sound', path: '/app/static/sounds/bgm_yuttari.mp3' }
      ],
      loadingOverlaySettings: {
        visibled: true,
        message: ''
      },
      lesson: {
        nextStage: {
          area: 1,
          stage: 1,
          isCompleted: false
        },
        progressPercentage: 0,
        totalStageCount: 0
      },
      today: moment().format('YYYY-MM-DD'),
      yesterday: moment().subtract(1, 'days').format('YYYY-MM-DD'),
      walkthroughModalEnabled: true,
      walkthroughPages: [
        { path: '/app/static/html/top_walkthrough_1.html' },
        { path: '/app/static/html/top_walkthrough_2.html' },
        { path: '/app/static/html/top_walkthrough_3.html' },
        { path: '/app/static/html/top_walkthrough_4.html' },
        { path: '/app/static/html/top_walkthrough_5.html' },
        { path: '/app/static/html/top_walkthrough_6.html' },
        { path: '/app/static/html/top_walkthrough_7.html' },
      ]
    }
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('User', [
      'setSignInStatus',
      'syncUserInfo',
      'getNextLessonStage',
      'migrateLessonProgress'
    ]),
    ...mapActions('Assets', ['fetchAssets', 'isAssetLoaded']),
    async load() {
      try {
        this.assetLoaded = await this.isAssetLoaded('top')

        // 設定情報習得
        const settings = await (
          await fetch('/app/static/json/settings.json', { cache: 'no-store' })
        ).json()
        const areas = _.get(settings, 'basicLesson.areas', [])

        // 旧式レッスンクリアデータのリセット(不要になり次第削除)
        await this.migrateLessonProgress()

        // レッスンのステージ総数取得
        this.lesson.totalStageCount = _.reduce(
          areas,
          (sum, area) => {
            return sum + area.stages.length
          },
          0
        )

        // レッスンの進捗率計算
        this.lesson.progressPercentage = Math.floor(
          (this.currentLessonProgressCount / this.lesson.totalStageCount) * 100
        )

        // レッスンの次ステージ取得
        this.lesson.nextStage = await this.getNextLessonStage(areas).catch(e => console.log(e))

        await this.fetchAssets({
          currentPage: 'top',
          assets: this.assets
        })
        setTimeout(() => {
          this.assetLoaded = true
        }, 500)
      } catch (e) {
        throw '読み込みエラー'
      }
    },
    async validateAuth() {
      if (!firebaseService.isAuthValid) {
        const isAuthValid = await firebaseService.validateAuth()
        if (!isAuthValid) {
          this.logout()
          throw null
        }
        firebaseService.isAuthValid = true
      }
    },
    syncUserData() {
      return new Promise(async (resolve) => {
        if (!firebaseService.isUserDataSyncFinished) {
          this.$set(this.loadingOverlaySettings, "message", 'ユーザーデータ同期中...')
          await this.syncUserInfo()
          firebaseService.isUserDataSyncFinished = true
          setTimeout(() => {
            this.$delete(this.loadingOverlaySettings, 'message')
            resolve()
          }, 500)
        } else {
          resolve()
        }
      })
    },
    async logout() {
      await this.$store.dispatch('User/setSignInStatus', false)
      this.$router.push('/signin')
    },
    handleMenuClick(type) {
      setTimeout(() => {
        switch (type) {
          case 'lesson':
            this.$router.push({
              path: '/lesson/select',
              query: {
                type: 'cancel',
                areaId: this.lesson.nextStage.area
              }
            })
            break
          case 'routine':
            // if (constants.IS_TRIAL) return
            this.$router.push('/routine/top')
            break
          case 'speedup':
            // if (constants.IS_TRIAL) return
            this.$router.push('/speedup/select')
            break
          case 'challenge':
            // if (constants.IS_TRIAL) return
            this.$router.push('/challenge/')
            break
          case 'customize':
            this.$router.push('/customize/')
            break
        }
      })
    },
    handleLogoutButtonClick() {
      this.logout()
    },
    handleBadgeClick() {
      this.$router.push('/challenge')
    },
    handleHelpClick() {
      this.walkthroughModalEnabled = true
    },
    handleWalkthroughModalClose() {
      this.walkthroughModalEnabled = false
    }
  },
  async mounted() {
    try {
      await firebaseService.init('default')
      await this.validateAuth()
      await this.syncUserData()
      await this.load()
      this.playBGM('bgmMenu')
      if(this.$cookie.get('top_walkthrough_permanentclose')) this.walkthroughModalEnabled = false


      this.$set(this.loadingOverlaySettings, "visibled", false)
    } catch(e) {
      if (typeof e !== 'string') return
      alert(e)
      console.log(e)
    }
  }
}
</script>

<style lang="scss" scoped>
.TopPage {
  display: flex;
  width: 100%;
  height: 100%;
}

.container {
  position: relative;
  padding: 20px 80px;
  width: 100%;
  background: linear-gradient(
    125deg,
    rgba(255, 240, 240, 1),
    rgba(255, 255, 255, 0)
  );
}

.main {
  position: relative;
  margin: 0 auto;
  padding: 20px 20px;
  width: 660px;
  height: 100%;
  border: 5px solid #000;
  background: #fff;
  text-align: center;
}

.title {
  position: relative;
  margin: 0 auto 10px;
  width: 400px;
  font-size: 5rem;

  img {
    width: 100%;
  }
}

.trialMark {
  position: absolute;
  bottom: 20px;
  left: 0;
  display: inline-block;
  padding: 5px 20px;
  border: 3px solid orange;
  color: orange;
  font-size: 2.5rem;
  border-radius: 20px;
}

.menu {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.menuItem {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding: 10px;
  width: 180px;
  height: 180px;
  border: 2px solid #000;
  font-size: 2.2rem;
  font-weight: bold;
  line-height: 1.5;
  border-radius: 10px;
  transition-property: background, color, padding, margin, transform;

  &:hover {
    background: yellow;
    cursor: pointer;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(1);
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
    &:hover {
      padding-left: 30px;
      background: transparent;
      color: #000;
      cursor: default;
    }
  }

  &--lesson {
    width: 380px;
  }

  &--routine {
    position: relative;
    flex-direction: column;
  }
}

.nextLabel {
  padding: 0 10px;
  background: orange;
  color: #fff;
  font-size: 1.8rem;
  border-radius: 20px;
}

.lessonProgress {
  position: relative;
  margin: 0 0 0 40px;

  @at-root .label {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 100px;
    color: orange;
    font-size: 2.5rem;
    z-index: 1;
  }
  @at-root .progressCircle {
    width: 100px;
    height: 100px;

    svg {
      transform: rotate(-90deg);
    }

    circle.base {
      fill: #fff;
      stroke: #eee;
      stroke-width: 3px;
    }

    circle.current {
      fill: transparent;
      stroke: orange;
      stroke-width: 2px;
      stroke-dasharray: 0, 100;
      stroke-linecap: round;
      transition: 0.5s ease stroke-dasharray;
    }
  }
}

.comboLabel {
  margin: 0;
  padding: 0 10px;
  min-width: 100px;
  background: lightseagreen;
  color: #fff;
  font-size: 1.6rem;
  border-radius: 20px;
}

.calendar {
  margin-top: 10px;
}

.taskIcon {
  position: absolute;
  top: -15px;
  right: -15px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: red;
  color: #fff;
  border-radius: 20px;
}

.version {
  position: fixed;
  bottom: 15px;
  right: 15px;
  color: #fff;
  font-size: 1.0rem;

  a {
    color: #fff;
    text-decoration: underline;
    cursor: pointer !important;
  }
}

.footer {
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  width: 100%;
  height: 80px;
  background: rgba(54, 42, 34, 0.9);
  color: #fff;
  text-align: center;

  .footerLeftMenu {
    display: flex;
  }

  .contactButton,
  .helpButton,
  .logoutButton {
    display: block;
    margin: 5px 5px;
    padding: 10px 20px;
    background: rgb(133, 108, 93);
    color: #fff;
    text-decoration: none;
    border-radius: 5px;
    transition: none 0.3s;
    transition-property: opacity, transform;
    &:hover {
      opacity: 0.8;
      transform: scale(1.05);
    }
  }

  .footerRightMenu {
    display: flex;
    align-items: center;
  }

  .userName {
    margin: 0 20px 0px 0;
    display: inline-block;
    vertical-align: middle;
  }

  .rankBadge {
    margin: 0 5px 0 0;
    width: 60px;
    height: 50px;
  }

}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 300%;
  height: 300%;
  background: url(../assets/bg_wood.jpg) repeat;
  // https://www.flickr.com/photos/seier/4342331255/sizes/l/
  animation: infinitescroll 20s linear infinite;
  z-index: -1;
}

@keyframes infinitescroll {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(-1024px, -768px, 0);
  }
}
</style>
